import React, { Component } from 'react';
import {Item, Container, Divider} from 'semantic-ui-react'

class Projects extends Component {

  render() {
    const items = [
      {
        childKey: 0,
        image: 'http://tlgraham.com/weneverdoanything.JPG',
        header: 'WeNeverDoAnything.com',
        description: `WeNeverDoAnything is a web application that shows users what recurring events are happening near them.
          These events include trivia, karaoke, and open mics. The back end is written in Go and PostgreSQL while the front end uses
          Google maps API to display the results.`,
        meta: <a href="http://github.com/tannergr/trivtracker"><i class="github icon"></i>Check out on GitHub</a>,
        extra: "Go, PostgreSQL, Javascript, HTML, CSS, Git, Heroku, OAUTH2",
      },
      {
        childKey: 1,
        image: 'https://www.w3schools.com/w3css/img_lights.jpg',
        header: 'Reddit Thread Search',
        description: <p>Reddit.tlgraham.com is a search engine for finding relevent comments in recurring daily threads. It is written in python with flask and uses the reddit API via PRAW (python reddit API wrapper). <a href="reddit.tlgraham.com">Try it out</a></p> ,
        meta: <a href="http://github.com/tannergr/redditthreadsearch"><i class="github icon"></i>Check out on GitHub</a>,
        extra:"Python, Flask, Javascript, HTML CSS, Git, Heroku",
      },
      {
        childKey: 2,
        image: 'https://www.w3schools.com/w3css/img_lights.jpg',
        header: 'This Site',
        description: <p>This site is a personal site for me, Tanner. It was also My first use of React with Semantic UI for CSS</p> ,
        meta: <a href="http://github.com/tannergr/personalwebsitev2"><i class="github icon"></i>Check out on GitHub</a>,
        extra:"React, Javascript, HTML, CSS, Semantic UI",
      },
      {
        childKey: 3,
        image: 'http://tlgraham.com/drone.JPG',
        header: 'Operational Awareness of UAVs',
        description: `For my final year capstone project I worked in a team to develop a drone detecting
              system. The system uses an SDR for radio scanning, Matlab for signal processing,
              and Java for the frontend.`,
        // meta: ,
        extra: 'Java, Python, Matlab, Git, SDR, LaTex',
      },
      {
        childKey: 4,
        image: 'http://tlgraham.com/fraservalleytree.JPG',
        header: 'FraserValleyTreeService.com',
        description: `Fraser Valley Tree Service is a Langley Arborist business that needed an updated
              website to help drive business. As the sole developer, I used JQuery and Semanitic UI
              to develop the single page website.`,
        meta: <a href="http://FraserValleyTreeService.com">Link</a>,
        extra: 'Javascript, jQuery, HTML, CSS, Semantic UI',
      }
    ];

    return(
      <div>
        <Divider hidden horizontal />
        <Divider hidden horizontal />
        <Container>
          <Item.Group left items={items} divided />
        </Container>
      </div>
    );
  }

}

export default Projects;



// WEBPACK FOOTER //
// ./src/Content/Pages/Projects.js